export const TestHooks = {
	EditMatterDetailsButton: 'edit-matter-details-button',
	EditKeyDatesButton: 'edit-key-dates-button',
	EditKeysButton: 'edit-keys-button',
	BillsAndDebtsContainer: 'bills-and-debts-container',
	PillFileStatus: 'pill-file-status',
	PillFileName: 'pill-file-name',
	PillFileNumber: 'pill-file-number',
	PillAccountingNumber: 'pill-accounting-number',
	PillOffice: 'pill-office',
	PillRefinance: 'pill-refinance',
	PillOpening: 'pill-opening',
	PillRequisition: 'pill-requisition',
	PillCompletionNA: 'pill-completion-na',
	PillAppointment: 'pill-appointment',
	PillClosing: 'pill-closing',
	PillClosingNA: 'pill-closing-na',
	PillOccupancy: 'pill-occupancy',
	PillOccupancyNA: 'pill-occupancy-na',
	PillPropertyTypeUsage: 'pill-property-type-usage',
	PillPropertyTypeLabel: 'pill-property-type-label',
	PillStatus: 'pill-status',
	PillTenanted: 'pill-tenanted',
	PillParcelOfTiedLand: 'pill-parcel-of-tied-land',
	PillReleased: 'pill-released',
	GoToGoogleMapsDiv: 'go-to-google-maps-div',
	PropertyAddressLink: 'property-address-link',
	PropertyDetails: 'property-details',
	GoToEncumbranceDiv: 'go-to-encumbrance-div',
} as const;
